// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"rv-z","imageAndVideoCount":"sv-z","imageAndVideoContainer":"tv-z","viewAllReviews":"uv-z"};